module.exports = __webpack_public_path__ + "static/media/RP-61.21eae001.pdf";